import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { createToothThunk, updateToothThunk } from "../../redux/slices/toothSlice";
import { getApiErrorMessage } from "../../utils/apiError";

const EMPTY = { toothName: "" };

const ToothModal = ({ show, onClose, editRecord }) => {
  const dispatch = useDispatch();
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm(editRecord ? { ...EMPTY, ...editRecord } : EMPTY);
  }, [editRecord, show]);

  const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.toothName.trim()) {
      Swal.fire("Required", "Tooth Name is required.", "warning"); return;
    }
    setSaving(true);
    try {
      if (editRecord?.toothID || editRecord?.id) {
        await dispatch(updateToothThunk({ id: editRecord.toothID || editRecord.id, data: form })).unwrap();
      } else {
        await dispatch(createToothThunk(form)).unwrap();
      }
      Swal.fire({ toast: true, position: "top-end", icon: "success", title: `Tooth ${editRecord ? "updated" : "added"} successfully`, showConfirmButton: false, timer: 2000 });
      onClose();
    } catch (err) {
      Swal.fire("Error", getApiErrorMessage(err, "Failed to save tooth."), "error");
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 custom-modal-header">
              <div className="page-title">
                <h4>{editRecord ? "Edit Tooth" : "Add Tooth"}</h4>
              </div>
              <button type="button" className="close" onClick={onClose}><span>×</span></button>
            </div>
            <div className="modal-body custom-modal-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-12 mb-3">
                    <label className="form-label">Tooth Name <span className="text-danger">*</span></label>
                    <input className="form-control" value={form.toothName} onChange={set("toothName")} placeholder="e.g. 11, Upper Right Central Incisor" />
                  </div>
                </div>
                <div className="modal-footer-btn">
                  <button type="button" className="btn btn-cancel me-2" onClick={onClose}>Cancel</button>
                  <button type="submit" className="btn btn-submit" disabled={saving}>
                    {saving ? "Saving..." : editRecord ? "Save Changes" : "Add Tooth"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" onClick={onClose} />
    </>
  );
};

export default ToothModal;
